const initialState = {
    user: {},
    isAuthenticated: false,
    access_token: null
}

const auth = (state = initialState, action) => {
    switch (action.type) {
        case 'SIGN_IN':
            return {
                ...state,
                user: action.payload.user,
                isAuthenticated: true,
                access_token: action.payload.api_token
            }

        case 'LOG_OUT':
            return {
                ...state,
                isAuthenticated: false,
                user: {},
            }



        default:
            return state
    }
}

export default auth;